import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  prefix: {
    width: 75,
    marginRight: 15,
  },
  number: { width: 'calc(100% - 50px)' },
}));
